import React from 'react';

import { HOME_TRANSACTIONS } from 'constants/shared/routes';
import useTranslate from 'lib/languages/useTranslate';
import SectionTitle from '../../sectionTitle/presentational/SectionTitle';

interface ErrorProps {
    message?: React.ReactNode;
    className?: string;
    backRoute?: string;
}

const ErrorMessage = ({
    message = 'An error occurred',
    className = '',
    backRoute = HOME_TRANSACTIONS,
}: ErrorProps) => {
    const translate = useTranslate('generic');
    return (
        <div className={`error-message ${className}`}>
            <SectionTitle title={translate('error')} backRoute={backRoute} />
            <p>{message}</p>
        </div>
    );
};

export default ErrorMessage;
